import React from 'react';
import { motion } from 'framer-motion';
import { Target, TrendingUp, BarChart3, RefreshCw } from 'lucide-react';
const pillars = [{
  icon: Target,
  title: 'Ejecución táctica profesional',
  description: 'Implementación precisa de campañas en las plataformas publicitarias más relevantes para tu negocio.'
}, {
  icon: TrendingUp,
  title: 'Optimización constante',
  description: 'Monitoreo diario y ajustes estratégicos para maximizar el rendimiento de cada anuncio.'
}, {
  icon: BarChart3,
  title: 'Análisis de métricas clave',
  description: 'Interpretación profunda de los datos para entender qué funciona y por qué.'
}, {
  icon: RefreshCw,
  title: 'Mejora continua del rendimiento',
  description: 'Ciclos de iteración rápidos para escalar resultados y reducir costos innecesarios.'
}];
export function AboutService() {
  return <section className="py-20 bg-white" data-id="element-11">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-12">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-13">
          <h2 className="text-3xl md:text-4xl font-bold text-navy-900 mb-6" data-id="element-14">
            Un enfoque diferente para tu publicidad digital
          </h2>
          <p className="text-lg text-slate-600 leading-relaxed" data-id="element-15">
            No se trata solo de crear anuncios. Se trata de ejecutar con
            precisión, medir cada resultado y optimizar de forma continua para
            que tu inversión genere retorno real.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-16">
          {pillars.map((pillar, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1,
          duration: 0.5
        }} className="bg-slate-50 rounded-xl p-6 border border-slate-100 hover:border-blue-100 transition-colors" data-id="element-17">
              <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mb-6 text-blue-600" data-id="element-18">
                <pillar.icon className="w-6 h-6" data-id="element-19" />
              </div>
              <h3 className="text-xl font-bold text-navy-900 mb-3" data-id="element-20">
                {pillar.title}
              </h3>
              <p className="text-slate-600 text-sm leading-relaxed" data-id="element-21">
                {pillar.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}